import request from '@/utils/request.js'

/**
 * 获取登录盐
 */
export function getLoginSalt (username) {
  return request({
    url: '/ant/api/sys/user/getLoginSalt',
    method: 'POST',
    data: {username: username}
  })
}

// 获取token
export function loginApi (username, passcode) {
  return request({
    url: '/ant/api/sys/user/v2/login',
    method: 'POST',
    data: {username: username, passcode: passcode}
  })
}
// 获取用户信息
export function getUserName (token) {
  return request({
    url: '/auth/api/info/token',
    method: 'POST',
    data: { token: token }
  })
}
// 获取菜单
export function getMenus (sysId) {
  return request({
    url: `/auth/api/menus/sys/${sysId}`,
    method: 'GET'
  })
}

// 退出登录
export function logout (data) {
  return request({
    url: '/auth/api/logout',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/Api/login.js